/** Global Files */
export const GET_FILES = 'GET_FILES';
export const GET_FILES_SUCCESS = 'GET_FILES_SUCCESS';

export const ADD_FILE = 'ADD_FILE';
export const EDIT_FILE = 'EDIT_FILE';
export const DELETE_FILES = 'DELETE_FILES';
export const ARCHIVE_FILES = 'ARCHIVE_FILES';
export const SHARE_FILE = 'SHARE_FILE';
export const UN_SHARE_FILE = 'UN_SHARE_FILE';
